import { render, staticRenderFns } from "./common-loca.vue?vue&type=template&id=277d9df0"
import script from "./common-loca.vue?vue&type=script&lang=js"
export * from "./common-loca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports